<script lang="ts">
  import type { Filter } from '../global'

  export let id: string
  export let label: string
  export let name: string
  export let options: Array<Filter.Option>
  export let value: string
</script>

<div class="flex flex-col lg:flex-row lg:items-center lg:gap-1">
  <label for={id}>{label}</label>
  <select {name} {id} class="select grow" bind:value>
    {#each options as { value, text }}
      <option {value}>{text}</option>
    {/each}
  </select>
</div>
